export default "__VITE_ASSET__CcwTggWL__"